import {
  BarChart3,
  Building2,
  Calendar,
  Car,
  CreditCard,
  FileSpreadsheet,
  FileText,
  HelpCircle,
  LayoutDashboard,
  MapPin,
  MessageSquare,
  Navigation,
  PoundSterling,
  Radar,
  Settings,
  Shield,
  Truck,
  Users,
  type LucideIcon,
  Rocket,
} from "lucide-react";

export interface DesktopAdminNavItem {
  id: string;
  label: string;
  icon: LucideIcon;
  path: string;
}

export interface DesktopAdminNavGroup {
  key: "operations" | "finance" | "fleet" | "administration" | "settings";
  title: string;
  items: DesktopAdminNavItem[];
}

export const desktopAdminNavGroups: DesktopAdminNavGroup[] = [
  {
    key: "operations",
    title: "Operations",
    items: [
      { id: "dashboard", label: "Dashboard", icon: LayoutDashboard, path: "/dashboard" },
      { id: "operations", label: "Operations Centre", icon: Radar, path: "/operations" },
      { id: "create-job", label: "Create Job", icon: Truck, path: "/create-job" },
      { id: "schedule", label: "Schedule", icon: Calendar, path: "/schedule" },
      { id: "quick-quote", label: "Quick Quote", icon: FileText, path: "/quick-quote" },
      { id: "quote-builder", label: "Quote Builder", icon: FileText, path: "/quote-builder" },
      { id: "saved-quotes", label: "Saved Quotes", icon: FileText, path: "/saved-quotes" },
      { id: "completed", label: "Completed Jobs", icon: FileText, path: "/previous-jobs" },
    ],
  },
  {
    key: "finance",
    title: "Finance",
    items: [
      { id: "invoicing", label: "Invoices", icon: PoundSterling, path: "/invoicing" },
      { id: "expenses", label: "Expenses", icon: FileSpreadsheet, path: "/expenses" },
    ],
  },
  {
    key: "fleet",
    title: "Fleet",
    items: [
      { id: "drivers", label: "Driver Management", icon: Users, path: "/driver-management" },
      { id: "driver-tracking", label: "Driver Tracking", icon: Navigation, path: "/driver-tracking" },
      { id: "driver-messages", label: "Driver Messages", icon: MessageSquare, path: "/driver-messages" },
      { id: "vehicles", label: "Vehicles", icon: Car, path: "/vehicles" },
      { id: "customers", label: "Customers", icon: MapPin, path: "/customers" },
      { id: "subcontractors", label: "Subcontractors", icon: Building2, path: "/subcontractors" },
    ],
  },
  {
    key: "administration",
    title: "Administration",
    items: [
      { id: "analytics", label: "Analytics", icon: BarChart3, path: "/analytics" },
      { id: "manage-users", label: "Manage Users", icon: Shield, path: "/manage-users" },
      { id: "subscriptions", label: "Subscription", icon: CreditCard, path: "/subscription-status" },
    ],
  },
  {
    key: "settings",
    title: "Settings",
    items: [
      { id: "settings", label: "Settings", icon: Settings, path: "/settings" },
      { id: "setup-centre", label: "Setup Centre", icon: Rocket, path: "/setup-centre" },
      { id: "help", label: "Help & Guides", icon: HelpCircle, path: "/help-guides" },
    ],
  },
];

export function isDesktopAdminRouteActive(pathname: string, path: string) {
  if (path === "/dashboard") return pathname === path;
  return pathname === path || pathname.startsWith(`${path}/`);
}